import { useAuth } from 'react-oidc-context';

/** Nom affiché de repli lorsque l’utilisateur OIDC n’est pas connecté (POC). */
export const POC_CURRENT_USER_DISPLAY_NAME = 'Jean-Baptiste Martinelli';

function readDisplayNameFromProfile(profile: Record<string, unknown> | undefined): string {
  if (!profile) {
    return '';
  }

  const name = profile.name;

  if (typeof name === 'string' && name.trim() !== '') {
    return name.trim();
  }

  const givenName = profile.given_name;
  const familyName = profile.family_name;

  if (typeof givenName === 'string' && typeof familyName === 'string') {
    const fullName = `${givenName.trim()} ${familyName.trim()}`.trim();

    if (fullName !== '') {
      return fullName;
    }
  }

  return '';
}

/** Prénom et nom de l’utilisateur connecté (OIDC), ou repli POC. */
export function useCurrentUserDisplayName(): string {
  const auth = useAuth();
  const fromAuth = readDisplayNameFromProfile(auth.user?.profile as Record<string, unknown> | undefined);

  return fromAuth || POC_CURRENT_USER_DISPLAY_NAME;
}
